import { restaurantUtils } from "utils";
import moment from "moment";
import { baseConstants } from "../../constants";
import { requestService } from "services";
import axios from "axios";

const searchPersons = 2;

export const locationCity = (configData, selectedCity) => {
  const currentDate = moment().format("YYYY-MM-DD");
  const hasConfigRegions =
    configData?.regions && Array.isArray(configData.regions) && configData.regions.length > 0;
  const foundDefaultConfigRegion = hasConfigRegions
    ? configData.regions.find(
        (regionElement) => regionElement.name === baseConstants["BASE_LOCATION_WARSAW"]["name"]
      )
    : null;

  let specificLocation = restaurantUtils.cookieLocation()?.locationBounds
    ? restaurantUtils.cookieLocation().locationBounds
    : foundDefaultConfigRegion
      ? foundDefaultConfigRegion.locationBounds
      : baseConstants["BASE_LOCATION_WARSAW"].locationBounds;
  if (selectedCity) {
    const foundNewCity = configData.regions.find(
      (regionElement) =>
        (regionElement.name || "").toLowerCase() === (selectedCity || "").toLowerCase()
    );
    if (foundNewCity) {
      specificLocation = { ...foundNewCity.locationBounds };
    }
  }
  const city = selectedCity || restaurantUtils.cityFromCookie();
  return {
    currentDate,
    specificLocation,
    city
  };
};

export function loadPromotionData(configData, selectedCity, firstTime, seed) {
  const { currentDate, specificLocation } = locationCity(configData, selectedCity);
  return requestService.restaurantPromotionsForLocation(
    {
      from: currentDate,
      to: currentDate,
      location: specificLocation,
      selectedCity
    },
    seed
  );
}

export const loadSectionData = (
  section,
  configData,
  selectedCity,
  mainPageRows,
  firstTime,
  seed
) => {
  const sectionItemsPerRow = 4;
  const currentTime = moment().format("HH:mm:ss");
  const { currentDate, specificLocation, city } = locationCity(configData, selectedCity);
  const sectionsListRequest =
    /* city === selectedCity && !firstTime ? Promise.reject() : */
    requestService.sectionRestaurantList(
      0,
      mainPageRows * sectionItemsPerRow,
      {
        preferences: [],
        favorite: false,
        persons: searchPersons,
        reservationTime: `${currentDate}T${currentTime}`,
        location: specificLocation,
        sort: {
          sortBy: "popularity", //priority?
          asc: false
        },
        city: selectedCity,
        sectionId: section.id
      },
      seed
    );

  return axios
    .all([sectionsListRequest])
    .then(
      axios.spread((...responses) => {
        return {
          sectionItems: responses[0].slice(0, mainPageRows * sectionItemsPerRow)
        };
      })
    )
    .catch(() => {
      return {
        sectionItems: []
      };
    });
};

export const loadSections = (configData, selectedCity, firstTime, seed) => {
  const sectionsListRequest = requestService.sectionsList({ city: selectedCity });

  return axios
    .all([sectionsListRequest])
    .then(
      axios.spread(async (...responses) => {
        const respSections = responses[0];
        const ret = [];

        for (const section of respSections) {
          await loadSectionData(
            section,
            configData,
            selectedCity,
            section.mainPageRows,
            firstTime,
            seed
          ).then(
            (data) => {
              ret.push({
                ...section,
                sectionItems: data.sectionItems
              });
            },
            () => {
              ret.push({
                ...section,
                sectionItems: []
              });
            }
          );
        }

        return {
          sectionsList: ret
        };
      })
    )
    .catch(() => {
      return {
        sectionsList: undefined
      };
      //console.info('@error1', errors);
    });
};

export const loadMostPopularData = (
  configData,
  selectedCity,
  mostPopularPage,
  lastMostPopularCurrentPage,
  mostPopularItemsPerPage,
  firstTime,
  seed
) => {
  const currentTime = moment().format("HH:mm:ss");
  const { currentDate, specificLocation } = locationCity(configData, selectedCity);
  const mostPopularListRequest = requestService.restaurantList(
    {
      preferences: [],
      favorite: false,
      persons: searchPersons,
      reservationTime: `${currentDate}T${currentTime}`,
      location: specificLocation,
      sort: {
        sortBy: "popularity",
        asc: false
      },
      city: selectedCity
    },
    seed
  );

  return axios
    .all([mostPopularListRequest])
    .then(
      axios.spread((...responses) => {
        const mostPopularOffset = mostPopularPage * mostPopularItemsPerPage;
        const mostPopularSliceFrom = mostPopularOffset;
        const mostPopularLimit =
          mostPopularSliceFrom + mostPopularItemsPerPage <= responses[0].length
            ? mostPopularItemsPerPage
            : responses[0].length >= mostPopularItemsPerPage
              ? responses[0].length - mostPopularItemsPerPage
              : responses[0].length;
        const mostPopularSliceTo = mostPopularSliceFrom + mostPopularLimit;
        const mostPopularSliced = responses[0].slice(mostPopularSliceFrom, mostPopularSliceTo);

        return {
          mostPopular: responses[0],
          mostPopularSliced: mostPopularSliced
        };
      })
    )
    .catch(() => {
      return {
        mostPopular: [],
        mostPopularSliced: []
      };
      //console.info('@error1', errors);
    });
};
